module.exports = __webpack_public_path__ + "3cf53e12c703e39e824a65c94130e3ba.svg";